module.exports = __webpack_public_path__ + "static/media/pic12.1f72cf1c.jpg";